<script>
import config from '@/config/global.config'

export default {
  name: 'OldLink',

  props: {
    to: {
      required: true,
      type: [String]
    }
  },

  computed: {
    href () {
      return config.appUrl + this.to
    }
  },

  render (h) {
    return h('a', {
      attrs: {
        href: this.href
      }
    }, this.$slots.default)
  }
}
</script>
